import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { TextFormat } from 'react-jhipster';
import { Link, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './cliente.reducer';

export const ClienteDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id!));
  }, []);

  const clienteEntity = useAppSelector(state => state.cliente.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="clienteDetailsHeading">Cliente</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{clienteEntity.id}</dd>
          <dt>
            <span id="key">Key</span>
          </dt>
          <dd>{clienteEntity.key}</dd>
          <dt>
            <span id="nombre">Nombre</span>
          </dt>
          <dd>{clienteEntity.nombre}</dd>
          <dt>
            <span id="cuentaBancaria">Cuenta Bancaria</span>
          </dt>
          <dd>{clienteEntity.cuentaBancaria}</dd>
          <dt>
            <span id="claveInstitucion">Clave Institucion</span>
          </dt>
          <dd>{clienteEntity.claveInstitucion}</dd>
          <dt>
            <span id="tipoCuenta">Tipo Cuenta</span>
          </dt>
          <dd>{clienteEntity.tipoCuenta}</dd>
          <dt>
            <span id="numeroCertificado">Numero Certificado</span>
          </dt>
          <dd>{clienteEntity.numeroCertificado}</dd>
          <dt>
            <span id="aliasCertificado">Alias Certificado</span>
          </dt>
          <dd>{clienteEntity.aliasCertificado}</dd>
          <dt>
            <span id="digitoVerificador">Digito Verificador</span>
          </dt>
          <dd>{clienteEntity.digitoVerificador}</dd>
          <dt>
            <span id="pagoComision">Pago Comision</span>
          </dt>
          <dd>{clienteEntity.pagoComision}</dd>
          <dt>
            <span id="tipoPago">Tipo Pago</span>
          </dt>
          <dd>{clienteEntity.tipoPago}</dd>
          <dt>
            <span id="keySource">Key Source</span>
          </dt>
          <dd>{clienteEntity.keySource}</dd>
          <dt>
            <span id="keyPem">Key Pem</span>
          </dt>
          <dd>{clienteEntity.keyPem}</dd>
          <dt>
            <span id="certificadoPem">Certificado Pem</span>
          </dt>
          <dd>{clienteEntity.certificadoPem}</dd>
          <dt>
            <span id="extra1">Extra 1</span>
          </dt>
          <dd>{clienteEntity.extra1}</dd>
          <dt>
            <span id="extra2">Extra 2</span>
          </dt>
          <dd>{clienteEntity.extra2}</dd>
          <dt>
            <span id="extra3">Extra 3</span>
          </dt>
          <dd>{clienteEntity.extra3}</dd>
          <dt>
            <span id="extra4">Extra 4</span>
          </dt>
          <dd>{clienteEntity.extra4}</dd>
          <dt>
            <span id="extra5">Extra 5</span>
          </dt>
          <dd>{clienteEntity.extra5}</dd>
          <dt>
            <span id="extra6">Extra 6</span>
          </dt>
          <dd>{clienteEntity.extra6}</dd>
          <dt>
            <span id="extra7">Extra 7</span>
          </dt>
          <dd>{clienteEntity.extra7}</dd>
          <dt>
            <span id="extra8">Extra 8</span>
          </dt>
          <dd>{clienteEntity.extra8}</dd>
          <dt>
            <span id="extra9">Extra 9</span>
          </dt>
          <dd>{clienteEntity.extra9}</dd>
          <dt>
            <span id="extra10">Extra 10</span>
          </dt>
          <dd>{clienteEntity.extra10}</dd>
          <dt>
            <span id="createdBy">Created By</span>
          </dt>
          <dd>{clienteEntity.createdBy}</dd>
          <dt>
            <span id="createdDate">Created Date</span>
          </dt>
          <dd>
            {clienteEntity.createdDate ? <TextFormat value={clienteEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="lastModifiedBy">Last Modified By</span>
          </dt>
          <dd>{clienteEntity.lastModifiedBy}</dd>
          <dt>
            <span id="lastModifiedDate">Last Modified Date</span>
          </dt>
          <dd>
            {clienteEntity.lastModifiedDate ? (
              <TextFormat value={clienteEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>User</dt>
          <dd>{clienteEntity.user ? clienteEntity.user.login : ''}</dd>
        </dl>
        <Button as={Link as any} to="/cliente" replace variant="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button as={Link as any} to={`/cliente/${clienteEntity.id}/edit`} replace variant="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default ClienteDetail;
